"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteRotation = void 0;
const react_1 = require("react");
const useSiteManifest_1 = require("./useSiteManifest");
function useSiteRotation() {
    var _a;
    const [_b] = useSiteManifest_1.useSiteManifest(), { data: manifest } = _b, res = __rest(_b, ["data"]);
    const rotation = (_a = manifest === null || manifest === void 0 ? void 0 : manifest.mapRotation) !== null && _a !== void 0 ? _a : null;
    return react_1.useMemo(() => (Object.assign(Object.assign({}, res), { data: rotation })), [res, rotation]);
}
exports.useSiteRotation = useSiteRotation;
//# sourceMappingURL=useSiteRotation.js.map